import ExportLearningResultReportData from './ExportLearningResultReportData';

export default ExportLearningResultReportData;
